import axios from 'axios';

export const DOC_URL = '/api/document';
export const LEGACY_URL = 'api/docs/legacy';
export const CREATE_DOC = '/api/document';
export const GET_DOCS = '/api/documents';
export const GET_PUBLIC_DOC = '/api/_public/document';

export function getLegacy() {
  return axios.get(LEGACY_URL);
}

export function createDoc(data: any) {
  return axios.post(CREATE_DOC, data);
}

export function editDoc(id: any, data: any) {
  return axios.put(`${DOC_URL}/${id}/edit`, data);
}

export function getDoc(code: any) {
  return axios.get(`${DOC_URL}/${code}`);
}

export function getDocs(params: any) {
  return axios.get(GET_DOCS, params);
}

export function getPublicDoc(code: any) {
  return axios.get(`${GET_PUBLIC_DOC}/${code}`);
}

export function getRequisites() {
  return axios.get('/api/settings/requisites');
}

export function postRequisites(data: {
  requisites: {
    inn: string;
    kpp: string;
    ogrn: string;
    legal_address: string;
    post_address: string;
    payment_account: string;
    bank: string;
    bank_bic: string;
    correspondent_account: string;
    owner: string;
  };
}) {
  return axios.post('/api/settings/requisites', data);
}
